import React from 'react'
import DatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker'
import classNames from 'classnames'

import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'

import IFormFieldProps from 'interfaces/form-field-props'
import ErrorField from '../error-field/ErrorField'
import InputLabel from '../input-label/InputLabel'
import styles from './DatePickerInput.module.scss'

interface IDateField extends IFormFieldProps {
  minDate?: Date
  maxDate?: Date
  popperClassName?: string
  dateFormat?: string
  DatePickerProps?: Partial<ReactDatePickerProps>
  disabled: boolean
}

const DatePickerInput: React.FC<IDateField> = ({
  name,
  value,
  onChange,
  label,
  minDate = undefined,
  maxDate = undefined,
  error = '',
  className,
  classes,
  popperClassName,
  dateFormat,
  DatePickerProps,
  isInvalid,
  isValid,
  disabled,
}) => {
  registerLocale('es', es)

  return (
    <div className={classNames(styles.datePickerContainer, className)}>
      <InputLabel label={label || ''} />
      <DatePicker
        className={classNames('form-control', classes?.input, {
          'is-invalid': isInvalid,
          'is-valid': isValid,
        })}
        name={name}
        locale="es"
        dateFormat={dateFormat || 'dd/MM/yyyy'}
        minDate={minDate ? new Date(minDate) : undefined}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        selected={value ? new Date(value) : undefined}
        onChange={onChange}
        popperClassName={popperClassName}
        disabled={disabled}
        {...DatePickerProps}
      />
      {error && <ErrorField text={error} />}
    </div>
  )
}

export default DatePickerInput
